/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesMyTeam {
	HIRED_AND_FIRED = "res://senior.com.br/analytics/hcm/team/manager/hiredAndFiredSummary", //ok
	HEADCOUNT_BY_CONTRACT_TYPE = "res://senior.com.br/analytics/hcm/team/manager/headcountByContractType", //ok
	// PERSONAL_DATA = "res://senior.com.br/analytics/hcm/public-profile/personalData",
	// MY_PERSONAL_DATA = "res://senior.com.br/analytics/hcm/my-profile/personalData",
	EDUCATIONAL_LEVEL = "res://senior.com.br/analytics/hcm/team/manager/educationDegree", //ok
	// PUBLIC_CURRENT_EMPLOYMENT_SITUATION = "res://senior.com.br/analytics/hcm/public-profile/currentSituationOfEmploymentContract",
	// PUBLIC_PERSONAL_INTERESTS = "res://senior.com.br/analytics/hcm/public-profile/myPersonalInterests",
	// PUBLIC_ACADEMIC_PROFILE = "res://senior.com.br/analytics/hcm/public-profile/trainning",
	// PUBLIC_EMERGENCY_CONTACTS = "res://senior.com.br/analytics/hcm/public-profile/emergencyContacts",
	// PUBLIC_PROFESSIONAL_CERTIFICATION = "res://senior.com.br/analytics/hcm/public-profile/professionalCertifications",
	// PUBLIC_PROFESSIONAL_EXPERIENCE = "res://senior.com.br/analytics/hcm/public-profile/professionalExperience",
	// PROFESSIONAL_PROFILE_RESUME = "res://senior.com.br/analytics/hcm/my-profile/professionalProfile/sumary",
	// BANK_DATA = "res://senior.com.br/analytics/hcm/my-profile/personalData/bankingData",
	// ADDRESS_DATA = "res://senior.com.br/analytics/hcm/my-profile/personalData/adress",
	// PROFESSIONAL_EXPERIENCE = "res://senior.com.br/analytics/hcm/my-profile/professionalProfile/experience",
	// MY_COMPETENCIES = "res://senior.com.br/analytics/hcm/my-profile/professionalProfile/myCompetencies",
	// MY_EMERGENCY_CONTACTS = "res://senior.com.br/analytics/hcm/my-profile/personalData/emergencyContacts",
	WORKFORCE_BY_GENERATION = "res://senior.com.br/analytics/hcm/team/manager/workforceByGeneration",//ok
	TEAM_GALLERY_MANAGER = "res://senior.com.br/analytics/hcm/team/manager/teamGallery", //ok
	TEAM_GALLERY_LED = "res://senior.com.br/analytics/hcm/team/employee/teamGallery", //ok
	ABSENTEEISM = "res://senior.com.br/analytics/hcm/clocking/manager/absenteeismSummary",
	OVERTIME_HOURS_IN_CALCULATION_PERIOD = "res://senior.com.br/analytics/hcm/time/overtimeCalculationPeriod",
	TRAINING_EVOLUTION = "res://senior.com.br/analytics/hcm/career/manager/trainingEvolution",
	CHAIN_OF_COMMAND = "res://senior.com.br/analytics/hcm/team/manager/chainOfCommand"
}
/**
 * Cards da página Manager, aba Team
 */
export enum PermissionResourcesMyTeamManager {
	TEAM_GALLERY_MANAGER = "res://senior.com.br/analytics/hcm/team/manager/teamGallery",
	HEADCOUNT_BY_CONTRACT_TYPE = "res://senior.com.br/analytics/hcm/team/manager/headcountByContractType",
	EDUCATIONAL_LEVEL = "res://senior.com.br/analytics/hcm/team/manager/educationDegree",
	WORKFORCE_BY_GENERATION = "res://senior.com.br/analytics/hcm/team/manager/workforceByGeneration",
	HIRED_AND_FIRED = "res://senior.com.br/analytics/hcm/team/manager/hiredAndFiredSummary"
}

/**
 * Cards pertencentes ao Painel de Gestão, porém situados na aba Ponto
 */
export enum PermissionResourcesMyTeamManagerAppointment {
	ABSENTEEISM = "res://senior.com.br/analytics/hcm/clocking/manager/absenteeismSummary",
	OVERTIME_HOURS_IN_CALCULATION_PERIOD = "res://senior.com.br/analytics/hcm/time/overtimeCalculationPeriod"
}

/**
 * Cards pertencentes ao Carreira e Sucessão, porém situados na aba Equipe > Perfil da equipe
 */
export enum PermissionResourcesMyTeamManagerCareer {
	TRAINING_EVOLUTION = "res://senior.com.br/analytics/hcm/career/manager/trainingEvolution",
	CHAIN_OF_COMMAND = "res://senior.com.br/analytics/hcm/team/manager/chainOfCommand"
}

export enum PermissionResourcesMyTeamManagerLed {
	TEAM_GALLERY_MANAGER = "res://senior.com.br/analytics/hcm/team/manager/teamGallery"
}

/**
 * Cards da página Manager, aba Team, sub-aba Feature
 */
export enum PermissionResourcesMyTeamManagerFeature {
	HEADCOUNT_BY_CONTRACT_TYPE = "res://senior.com.br/analytics/hcm/team/manager/headcountByContractType",
	EDUCATIONAL_LEVEL = "res://senior.com.br/analytics/hcm/team/manager/educationDegree",
	WORKFORCE_BY_GENERATION = "res://senior.com.br/analytics/hcm/team/manager/workforceByGeneration",
	HIRED_AND_FIRED = "res://senior.com.br/analytics/hcm/team/manager/hiredAndFiredSummary"
}

/**
 * Cards da página My, aba Team
 */
export enum PermissionResourcesMyTeamMy {
	TEAM_GALLERY_LED = "res://senior.com.br/analytics/hcm/team/employee/teamGallery"
}
